const InstituteFeeHeader = [
    { id: 1, label: "Total LLB/ BA LLB course fee (INR)", var: "coursefee" },
    { id: 2, label: "Total hostel fee for LLB/ BA LLB (INR)", var: "hostelfee" },
];

export default InstituteFeeHeader;
